import { useDispatch, useSelector } from 'react-redux';
import { setSelectedCurrency } from '../../../redux/fiat-currencies';
import React from 'react';
import { RootState } from 'typesafe-actions';
import { CURRENCIES } from '../../../utils/currency';
import { Currency } from '@make-software/csprclick-ui';

interface UseCurrencyItemsHookProps {
  currencies: Currency[];
  currentCurrency: Currency;
  onChangeCurrency: (newCurrency) => void;
}

export const useCurrencies = (): UseCurrencyItemsHookProps => {
  const dispatch = useDispatch();
  const selectedCurrency = useSelector(
    (state: RootState) => state.currencies.selectedCurrency
  );
  const availableCurrencies = useSelector(
    (state: RootState) => state.currencies.availableCurrencies
  );

  const currencies: Currency[] =
    (availableCurrencies
      ?.sort((a, b) => a.code.charCodeAt(0) - b.code.charCodeAt(0))
      .map((ac) => {
        return {
          ...ac,
          title: CURRENCIES[ac.code],
        };
      }) as unknown as Currency[]) || [];

  const handleChangeCurrency = (newCurrency) => {
    dispatch(setSelectedCurrency(newCurrency));
  };

  return {
    currencies: currencies,
    currentCurrency: selectedCurrency as unknown as Currency,
    onChangeCurrency: handleChangeCurrency,
  };
};
